<template>
  <v-container>
    <v-card>
      <payslip-ea-form :employee-uid="employee.employee_uid" />
    </v-card>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      PayslipEaForm: () => import('@/components/payslip/EAForm'),
    },
    metaInfo () {
      return {
        title: 'EA Form',        
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
  }
</script>
